/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, April 2020
 *
 *****************************************************************************/


import React from "react";
import { constant } from "./../../../shared/constants/constants";
import Tooltip from "./../../../Tooltip/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import styles from "./SideDrawer.module.css";
import HelpOutline from "@material-ui/icons/HelpOutline";


const useStyles = makeStyles((theme) => ({
  root: {
    "&$checked": {
      color: "#8fa225",
    },
  },
  checked: {},
}));

// checkbox card
const GeometryCheckbox = ({ checked, handleChange }) => {
  const classes = useStyles();
  return (
    <div className={styles.CheckBoxCont}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleChange}
            name="showAll"
            classes={{
              root: classes.root,
              checked: classes.checked,
            }}
          />
        }
        label={constant.SHOW_ALL_PROPERTIES}
      />
      <Tooltip
        style={{ color: "grey" }}
        title={constant.I_ICON_HOVER_LIVE}
        arrow>
        <HelpOutline />
      </Tooltip>
    </div>
  );
};

export default GeometryCheckbox;
